import { AutogenModelRateHeaderLookup, AutogenRowRateHeaderLookup } from "./autogen/AutogenModelRateHeaderLookup";

export class ModelRateHeaderLookup extends AutogenModelRateHeaderLookup<RowRateHeaderLookup> {
	constructor() {
		super(RowRateHeaderLookup);
	}
}

export class RowRateHeaderLookup extends AutogenRowRateHeaderLookup {
}